import Spin                    from 'antd/lib/spin';
import { observer }            from 'mobx-react';
import LoginPage               from 'pages/LoginPage/LoginPage';
import React                   from 'react';
import { authenticationStore } from 'stores';
import Layout                  from '../Layout/Layout';

export default observer(props => {
	if (!authenticationStore.isReady) {
		return <Spin className="app-centered-spin" size="large" />;
	}

	if (!authenticationStore.isAuthenticated) {
		return <LoginPage {...props} />;
	}

	return <Layout {...props} />;
});
